<section
  class="header w-12 article-backround"
  [style.background-image]="articleImageSrc"
  [title]="article.name"
>
  <div class="container">
    <div
      class="article-title w-6"
      [class.ml-1]="deviceService.isDesktop()"
      [class.w-12]="deviceService.isMobileOrTablet()"
    >
      @if (article.place) {
        <div class="destination">
          <p class="upper">
            {{ article.place }}, <em>{{ article.destination?.country }}</em>
          </p>
        </div>
      }
      <h1>{{ article.name }}</h1>
      <div class="date">
        {{ article.updateDate | date: 'dd MMMM yyy' }}
      </div>
    </div>
  </div>
</section>
<div class="article-container w-12">
  <div class="container m-auto" #articleContainer>
    <div
      class="w-8"
      [class.ml-2]="deviceService.isDesktop()"
      [class.w-12]="deviceService.isMobileOrTablet()"
    >
      <div class="description">
        <app-inner-html [content]="article.description"></app-inner-html>
      </div>
    </div>
    @if (article.stickyLinks && article.stickyLinks.length > 0) {
      <div
        class="sticky-links w-8"
        [class.ml-2]="deviceService.isDesktop()"
        [class.w-12]="deviceService.isMobileOrTablet()"
      >
        <app-sticky-links
          [stickyLinks]="article.stickyLinks"
          [title]="article.stickyLinksTitle"
        ></app-sticky-links>
      </div>
    }
    @if (article.hasSummary && articleSummaryTitles && articleSummaryTitles.length > 0) {
      <div
        class="w-8 summary"
        [class.ml-2]="deviceService.isDesktop()"
        [class.w-12]="deviceService.isMobileOrTablet()"
      >
        <app-summary [titles]="articleSummaryTitles"></app-summary>
      </div>
    }
    <div
      class="w-8 sections"
      appArticle
      [isMobile]="deviceService.isMobile()"
      [class.ml-2]="deviceService.isDesktop()"
      [class.w-12]="deviceService.isMobileOrTablet()"
    >
      @for (section of articleSections; track section.id) {
        <section [ngClass]="section.customClass">
          <ng-template templateHost [data]="section"></ng-template>
        </section>
      }
    </div>
  </div>
</div>
<div class="articles-container full-width">
  <div
    class="articles w-8 m-auto"
    [class.w-10]="deviceService.isMobileOrTablet()"
    [class.ml-1]="deviceService.isMobileOrTablet()"
  >
    <h2>Découvrir d'autres articles</h2>
    <div
      class="full-width"
      [class.row]="deviceService.isDesktop()"
      [class.articles-mobile]="deviceService.isMobileOrTablet()"
    >
      @for (dArticle of discoverArticles; track dArticle.id) {
        <app-article-card
          class="w-4"
          [class.w-6]="deviceService.isTablet()"
          [class.w-12]="deviceService.isMobile()"
          [article]="dArticle"
          [showDescription]="false"
        >
        </app-article-card>
      }
    </div>
  </div>
</div>
<div class="comments-container full-width">
  <div
    class="comments w-8 m-auto"
    [class.w-10]="deviceService.isMobile()"
    [class.w-9]="deviceService.isTablet()"
  >
    <div class="comments-header">
      <h2>
        {{ getCommentsNumber(article.comments) }}<ng-container> commentaire</ng-container
        >{{ getCommentsNumber(article.comments) > 1 ? 's' : '' }}
      </h2>
      @if (!deviceService.isMobile()) {
        <div class="link">
          <img
            loading="lazy"
            class="icon"
            alt="plus"
            ngSrc="/icons/plus.svg"
            width="12"
            height="12"
          />
          <a (click)="addComment()">
            <ng-container>Laisser un commentaire</ng-container>
            <div class="line"></div>
          </a>
        </div>
      }
    </div>
    @for (comment of article.comments; let i = $index; track comment.id) {
      <app-comment
        [comment]="comment"
        [isFirst]="i === 0"
        [isLast]="i === article.comments.length - 1"
        (onAnswerComment)="addComment($event)"
      ></app-comment>
    }
    @if (deviceService.isMobile()) {
      <div class="link mobile-link">
        <img
          loading="lazy"
          class="icon"
          alt="plus"
          ngSrc="/icons/plus.svg"
          width="12"
          height="12"
        />
        <a (click)="addComment()">
          <ng-container>Laisser un commentaire</ng-container>
          <div class="line"></div>
        </a>
      </div>
    }
  </div>
</div>
<!-- <div class="w-8 m-auto">
    <app-instagram-feed></app-instagram-feed>
  </div> -->
<p-dialog
  [(visible)]="showCommentModal"
  [modal]="true"
  [style]="!deviceService.isMobile() ? { width: '40vw' } : { width: '80vw' }"
>
  <ng-template pTemplate="header"
    ><ng-container> Laisser un commentaire </ng-container></ng-template
  >
  <form>
    <div class="form-group">
      <label for="name"> Ton nom, prénom ou pseudo </label>
      <input type="text" [(ngModel)]="commentModel.name" name="name" />
    </div>
    <div class="form-group">
      <label class="text"> Ton commentaire </label>
      <textarea [(ngModel)]="commentModel.text" name="text"></textarea>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a (click)="saveComment()">
        <ng-container>Envoyer</ng-container>
        <div class="line"></div>
      </a>
    </div>
  </ng-template>
</p-dialog>
